import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bemGenerator } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import { Link } from 'react-router-dom';
import T from '@prisjakt/ui-translate';
import PanelHeader from '@prisjakt/ui-panel-header';

import './index.scss';

const styles = bemGenerator('settings-user-data');

const UserData = props => {
  const { t } = useContext(AppContext);
  return (
    <div className={styles.block}>
      <PanelHeader
        title={t('account', 'userdata.userdata-title')}
        margin="bottom"
      />
      <p>
        <Link to="/privacy-settings">
          {t('tracking-settings', 'link.privacy-settings')}
        </Link>
      </p>
      <p>{t('account', 'userdata.userdata-description')}</p>
      <T domain="account">userdata.userdata-link.md</T>
      <T domain="account">userdata.exports-contact-info.md</T>
      {props.exports &&
        props.exports.nodes
          .filter(meExport => meExport.status === 'export_success')
          .map(
            (meExport, i, meExports) =>
              meExports.length - 1 === i && (
                <T domain="account" expiration_date={meExport.expirationDate}>
                  userdata.exports-download-info.md
                </T>
              )
          )}
    </div>
  );
};

UserData.propTypes = {
  exports: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

UserData.defaultProps = {
  exports: null,
};

export default connect(state => state.areas.account.me)(memo(UserData));
